import { render } from "./ClinVarVizualiser.vue?vue&type=template&id=83ed925a"
import script from "./ClinVarVizualiser.vue?vue&type=script&lang=js"
export * from "./ClinVarVizualiser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__